// removed by extract-text-webpack-plugin
module.exports = {"header":"MobileHeader-hashed__header__3l1ZE","header__back":"MobileHeader-hashed__header__back__397If","header__title":"MobileHeader-hashed__header__title__10Lw9"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/pagestructure/mobileheader/MobileHeader-hashed.scss
// module id = 1210
// module chunks = 0